import { $qs, $qsa } from './utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';


gsap.registerPlugin(ScrollTrigger, SplitText);

function mainMenu() {

    // console.info('main menu script 2:' + window.innerWidth);

    // switch menu style on contact page
    if(window.innerWidth < 768 && $qs('[data-name="contact-banner"]')){
    // if(window.innerWidth < 768 ){
            // switch menu style on contact page
            // console.info('update menu contact');
            let darkLogo = $qs('[data-name="dark-logo"]');
            gsap.set(darkLogo,{display: 'block'})
            $qs('[data-name="contact-banner"]').dataset.js = 'switch-menu-blue';

    }
    let switchBlue = $qsa('[data-js="switch-menu-blue"]');
    let switchWhite = $qsa('[data-js="switch-menu-white"]');
    let menuToggle = $qs('[data-js="toggle-main-menu"]');
    let hamburger = $qs('[data-name="hamburger"]');
    let hamburgerClose = $qs('[data-name="hamburger-close"]');
    let hamburgerParts = $qsa('[data-name="hamburger"] > *');
    let hamburgerLine = $qsa('[data-name="hamburger-line"]');
    let mainMenu = $qs('[data-name="main-menu"]');
    let mainMenuBG = $qs('[data-name="main-menu-bg"]');
    let mainMenuLogo = $qs('[data-name="main-menu-logo"]');
    let mainMenuMenu = $qs('[data-name="main-menu-menu"]');
    let mainMenuMenuItems = $qsa('[data-name="main-menu-menu"] li');
    const mainMenuMenuItemsLinks = $qsa('[data-name="main-menu-menu"] li a');
    let mainMenuSocial = $qs('[data-name="main-menu-social"]');
    const animatedCircles = $qsa('[data-name="animated-circles"] [data-js="move-circle"]');
    const animatedCirclesContain = $qs('[data-name="animated-circles"]');
    // console.info(animatedCirclesContain.getBoundingClientRect());
    const animatedCirclesContainX = animatedCirclesContain.getBoundingClientRect().top;
    const animatedCirclesContainY = animatedCirclesContain.getBoundingClientRect().right;



    mainMenuMenuItemsLinks.forEach(item => {
        // return;


        const italicSpan = document.createElement('span')    
        italicSpan.innerHTML = item.innerText;
        // console.info(item);
        const initialTitle = new SplitText(item, {type: "chars", charsClass: "char"});

        italicSpan.classList.add('inside-italic-hover');
        item.appendChild(italicSpan);
        // const chars = splitBannerTitle.chars;

        const hoverTitle = new SplitText(italicSpan, {type: "chars", charsClass: "char"});
        const timeline = gsap.timeline({paused: true});
        // timeline.to(initialTitle.chars, {opacity: 0, y: '-100%', stagger: '0.0', duration: 0.4}, 'start')
        //   .to(hoverTitle.chars, {opacity: 1, y: '-100%', stagger: '0.0', duration: 0.4},'start')
        timeline.to(initialTitle.chars, {opacity: 0, duration: 0.2, })
          .to(hoverTitle.chars, {opacity: 1, duration: 0.2},'start')
    
        item.addEventListener('mouseenter', (e) => {
          
          timeline.play();
    
        });
        item.addEventListener('mouseleave', (e) => {
          
          timeline.reverse();
    
        });
        
      });

      gsap.set(mainMenu, {visibility: 'hidden'});
      gsap.set(mainMenuMenuItems, {overflow: 'hidden', position: 'relative'});
      // gsap.set(mainMenuMenuItemsLinks, {display: 'block'});
      gsap.set(mainMenuLogo, {opacity: 0});

    menuToggle.addEventListener('click', () => {
        if(mainMenu.classList.contains('menu-open')){
        if(mainMenu.classList.contains('hamburger-blue')){
            gsap.to(hamburgerParts,{background: '#fff'});
            gsap.to(menuToggle,{background: '#00468B'});
            gsap.to(hamburgerLine,{background: '#00468B'});
        }
        $qs('body').classList.remove('overflow-hidden');

            mainMenu.classList.remove('menu-open')
            let tlHam = new gsap.timeline();
            tlHam.to(hamburgerClose, {opacity: 0})
            .to(hamburgerParts, {scaleX: 1, transformOrigin: 'left', stagger: 0.1})
            
            let tl = new gsap.timeline();
            tl
            .to(mainMenu, {opacity: 0, duraion: 0.3})
            .to(mainMenu, {visibility: 'hidden'})
            .set(mainMenu, {x:0})
        }else{
            gsap.to(hamburgerParts,{background: '#00468B'});
            gsap.to(menuToggle,{background: '#fff'});
            gsap.to(hamburgerLine,{background: '#fff'});

            $qs('body').classList.add('overflow-hidden');
            mainMenu.classList.add('menu-open')
            let tlHam = new gsap.timeline();
            tlHam.to(hamburgerParts, {scaleX: 0, transformOrigin: 'left', stagger: 0.1})
            .to(hamburgerClose, {opacity: 1});

        gsap.set(mainMenu, {x:'-100%',visibility: 'visible', opacity: 1})
        let tl = new gsap.timeline();
        tl
        .fromTo(mainMenuBG, { scale: 0, opacity: 0}, {transformOrigin: 'center', scale: 1, opacity:1, duration: 0.8})
        
        .fromTo(animatedCirclesContain, {opacity: 0}, {opacity: 1, duration: 0.6})
        .fromTo(mainMenuLogo, {opacity: 0}, {opacity: 1, duration: 0.3})

        .fromTo(mainMenuMenu, {opacity: 0}, {opacity: 1, duration: 0.01}, '-=0.3')
        .fromTo(mainMenuMenuItemsLinks, {transformOrigin: 'center', y: '100%'}, {transformOrigin: 'center', y: '0', stagger: 0.1})
        .fromTo(mainMenuSocial, {opacity: 0}, {opacity: 1, duration: 0.8})
        }
    });


    [...switchBlue].forEach((section) => {
        ScrollTrigger.create({
            trigger:section,
            start:"top 80px",
            end:"bottom 80px",
            onEnter: () => {
                mainMenu.classList.add('hamburger-blue');
                gsap.to(hamburgerParts,{background: '#fff'});
                gsap.to(menuToggle,{background: '#00468B'});
                gsap.to(hamburgerLine,{background: '#00468B'});
// console.info('switchBlue enter');
            },
            onEnterBack: () => {
                mainMenu.classList.add('hamburger-blue');
                gsap.to(hamburgerParts,{background: '#fff'});
                gsap.to(menuToggle,{background: '#00468B'});
                gsap.to(hamburgerLine,{background: '#00468B'});
// console.info('switchBlue enter');
            },
            // markers: true,
            // toggleActions:"restart restart none none"   
          })
    });
    [...switchWhite].forEach((section) => {
        ScrollTrigger.create({
            trigger:section,
            start:"top 80px",
            end:"bottom 80px",
            onEnter: () => {
                mainMenu.classList.remove('hamburger-blue');
                gsap.to(hamburgerParts,{background: '#00468B'});
                gsap.to(menuToggle,{background: '#fff'});
                gsap.to(hamburgerLine,{background: '#fff'});
                // console.info('switchWhite enter');
            },
            onEnterBack: () => {
                mainMenu.classList.remove('hamburger-blue');
                gsap.to(hamburgerParts,{background: '#00468B'});
                gsap.to(menuToggle,{background: '#fff'});
                gsap.to(hamburgerLine,{background: '#fff'});
                // console.info('switchWhite enter');
            },
            // markers: true,
            // toggleActions:"restart restart none none"   
          })
    })

      //footer menu hover animation

 



    if (!animatedCircles) return;

    [...animatedCircles].forEach((animatedCircle) => {
       

        $qs('body').addEventListener('mousemove', (e) => {
            // const cursor = e.target.parentNode.querySelector('.cursor-content');
            let x = e.clientX;
            let y = e.clientY;
            let distance = 200;
            // console.info('animatedCirclesContainX:' + animatedCirclesContainX);
            // console.info('animatedCirclesContainY:' + animatedCirclesContainY);
            x = x - animatedCirclesContainX/2;
            y = y - animatedCirclesContainY/2;
            x = x / distance;
            y = y / distance;
            // console.info('x:' + x);
            // console.info('y:' + y);
            gsap.to( animatedCircle, { transformOrigin: 'center', x: x, y: y, duration: 0.5 } );

        });


    });
}


export default mainMenu;